import {About as AboutUs} from '@geomatico/geocomponents';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {type FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import ConfigButton from '@/components/common/ConfigButton';

type Props = {
  hash: string;
  version: string;
  timestamp: number;
};

const About: FC<Props> = ({hash, version, timestamp}) => {
  const {t} = useTranslation();

  const [showAbout, setShowAbout] = useState<boolean>(false);

  return (
    <Stack direction="row" spacing={1} sx={{alignItems: 'flex-end'}}>
      <AboutUs
        isOpen={showAbout}
        onClose={() => setShowAbout(false)}
        version={version}
        hash={hash}
        timestamp={timestamp}
      >
        {/** biome-ignore lint/complexity/noUselessFragments: it is necesssary */}
        <>
          <Typography gutterBottom>{t('about.paragraph1')}</Typography>
          <Typography gutterBottom sx={{fontWeight: 700, textAlign: 'center', my: 2}}>
            {t('about.paragraph2')}
          </Typography>
          <Typography gutterBottom>{t('about.paragraph3')}</Typography>
          <Stack direction="row" spacing={2} sx={{width: '100%', flexWrap: 'wrap', justifyContent: 'center', mt: 5}}>
            <Box
              component="img"
              src="/images/logos/asefor.jpg"
              alt="asefor"
              sx={{height: 40, objectFit: 'cover', ml: 1, mb: 1, mt: 2}}
            />
            <Box
              component="img"
              src="/images/logos/finsa.jpg"
              alt="asefor"
              sx={{height: 40, objectFit: 'cover', ml: 1, mb: 1, mt: 2}}
            />
          </Stack>
          <Stack direction="row" spacing={2} sx={{width: '100%', flexWrap: 'wrap', justifyContent: 'center', my: 4}}>
            <Box
              component="img"
              src="/images/logos/fortop.jpg"
              alt="asefor"
              sx={{height: 40, objectFit: 'cover', ml: 1, mb: 1, mt: 2}}
            />
            <Box
              component="img"
              src="/images/logos/geomatico.jpg"
              alt="asefor"
              sx={{height: 40, objectFit: 'cover', ml: 1, mb: 1, mt: 2}}
            />
          </Stack>
        </>
      </AboutUs>
      <ConfigButton content="i" onClick={() => setShowAbout(!showAbout)} />
    </Stack>
  );
};
export default About;
